module.exports = __webpack_public_path__ + "static/media/spoonerism-task (4).9e50de75.mp3";